exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".allowScroll{overflow:auto}.split-view{overflow:hidden}#pane-container{max-height:calc(100vh - 130px);overflow:hidden}.pane-inner{padding-bottom:8px;min-height:100%;position:relative}#pane-left,#pane-right{height:auto;max-height:calc(100vh - 130px);overflow:auto}#pane-left::-webkit-scrollbar,#pane-right::-webkit-scrollbar{width:2px}#pane-left::-webkit-scrollbar-track,#pane-right::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.3)}#pane-left::-webkit-scrollbar-thumb,#pane-right::-webkit-scrollbar-thumb{background-color:#4382ce;outline:1px solid #708090}.preview-dropdown{max-height:400px;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/property-qc/Dashboard.vue
// module id = 805
// module chunks = 0